import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";
import { MultiSelectModule } from 'primeng/multiselect';
import { ErrormessageModule } from '../../validation/errormessage/errormessage.module';

import { PCPLotMultiSelectComponent } from "./pcp-lot-multi-select.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        MultiSelectModule,
        CheckboxModule,
        PCPLotMultiSelectComponent,
    ],
    exports: [PCPLotMultiSelectComponent]
})
export class PCPLotMultiSelectModule { }
